<template>
  <BaseItem
      ref="BaseItem"
      :item-uid="itemUid"
      :subtract-height="subtractHeight"
      parentComponent="CustomerTable"
      dto-detail-model="CustomerDetailQueryDTO"
      dto-save-model="CustomerSaveCommandDTO"
      dto_validate_model="CustomerValidateCommandDTO"
      dto-restore-model="CustomerRestoreCommandDTO"
      dto-filter-restore-model="CustomerDetailResponseDTO"
      store-name="CustomerTable"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
      @cancel="$emit('cancel')"
      @save="function(editedItem) {$emit('save', editedItem)}"
      :readonly="readonly"
      :dialog="dialog"
  >
    <template v-slot:body="{editedItem, lockPage, instance, slotHeight, editedItemCommon}">
      <v-sheet class="mx-3">
        <v-row>
          <v-col cols="12">
            <BaseFieldString
                v-if="!!editedItem && !!editedItem.property_state"
                v-model.number="editedItem.name"
                :property_state_field="editedItem.property_state.name"
                label="Name"
                counter
                maxlength="100"
            ></BaseFieldString>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8">
            <v-textarea
                dense
                v-model="editedItem.address"
                outlined
                clearable
                label="Address"
                @input="editedItem.address = $event !== '' ? $event : null"
            >
            </v-textarea>
          </v-col>
          <v-col cols="4">
            <v-textarea
                dense
                v-model="editedItem.phones"
                outlined
                clearable
                label="Phones"
                @input="editedItem.phones = $event !== '' ? $event : null"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-sheet>
    </template>
  </BaseItem>
</template>

<script>
// import {mapGetters, mapActions} from 'vuex';
// import {mapFields} from 'vuex-map-fields';
import {v4 as uuidv4} from "uuid";
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseItem from "@/components/Base/BaseItem";
import CustomerTable from "@/components/Product/Customer/CustomerTable";
import BaseColorPicker from "@/components/Base/BaseColorPicker";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldString from "@/components/Base/BaseFieldString";

export default {
  name: 'CustomerItem',
  props: {
    subtractHeight: {type: [Number], default: 240},
    height: {type: [Number], default: window.innerHeight},
    itemUid: {default: null},
    store_name: {type: [String], default: 'CustomerTable'},
    modalDialog: {type: [Boolean], default: false},
    dialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
    readonly: {type: [Boolean], default: false}
  },

  components: {
    ConfirmDialog,
    BaseItem,
    CustomerTable,
    BaseColorPicker,
    BaseFieldNumber,
    BaseFieldString,
  },

  computed: {},

  methods: {},

  async mounted() {

  }
  ,

  data() {
    return {}
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
}
</i18n>
